import { ParseResult } from "papaparse";
import React, { ChangeEvent, Component } from "react";
import "./VendorSourcesUploadModal.scss";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IErrorItemUpdateDTO from "../../../models/DTO/IErrorItemUpdateDTO";
import IOnProcessVendorSourcesCatalogItemsCsvDTO from "../../../models/DTO/IOnProcessVendorSourcesCatalogItemsCsvDTO";
import IOnProcessVendorSourcesCsvDTO from "../../../models/DTO/IOnProcessVendorSourcesCsvDTO";
import IOnProcessVendorSourcesLocationsCsvDTO from "../../../models/DTO/IOnProcessVendorSourcesLocationsCsvDTO";
import IProcessVendorSourcesCsvDTO from "../../../models/DTO/IProcessVendorSourcesCsvDTO";
import IProcessVendorSourcesLocationsCsvDTO from "../../../models/DTO/IProcessVendorSourcesLocationsCsvDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import FileUploadResourceTypeEnum from "../../../models/FileUploadResourceTypeEnum";
import IProcessedItemsDetails from "../../../models/IProcessedItemsDetails";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendorSourceLocationUploadDataRow from "../../../models/IVendorSourceLocationUploadDataRow";
import IVendorSourceUploadDataRow from "../../../models/IVendorSourceUploadDataRow";
import S3UploadTypeEnum from "../../../models/S3UploadTypeEnum";
import OwButton from "../../shared/OwButton/OwButton";
import OwCsvReader from "../../shared/OwCsvReader/OwCsvReader";
import OwS3Uploader from "../../shared/OwS3Uploader/OwS3Uploader";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwProcessedItemsDetails from "../../shared/OwProcessedItemsDetails/OwProcessedItemsDetails";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import OwTitle from "../../shared/OwTitle/OwTitle";
import { Socket } from "socket.io-client";

interface IVendorSourceCSVRow {
    Name: string;
    Email: string;
    "Require Submit Confirmation": string;
    "Bill To Name": string;
    "Bill To Company Name": string;
    "Bill To Address Line One": string;
    "Bill To Address Line Two": string;
    "Bill To Address Line Three": string;
    "Bill To City": string;
    "Bill To State": string;
    "Bill To Postal Code": string;
    "Bill To Country": string;
    "Bill To Phone": string;
    "Bill To Fax": string;
    "Bill To Email": string;
    "Ship To Name": string;
    "Ship To Company Name": string;
    "Ship To Address Line One": string;
    "Ship To Address Line Two": string;
    "Ship To Address Line Three": string;
    "Ship To City": string;
    "Ship To State": string;
    "Ship To Postal Code": string;
    "Ship To Country": string;
    "Ship To Phone": string;
    "Ship To Fax": string;
    "Ship To Email": string;
    "Vendor Source Guid (Blank on New, Do Not Edit)": string;
}

interface IVendorSourceLocationCSVRow {
    "Vendor Source Name": string;
    Name: string;
    "Internal Id": string;
    "Address Line One": string;
    "Address Line Two": string;
    "Address Line Three": string;
    City: string;
    State: string;
    "Postal Code": string;
    Country: string;
    "Location Guid (Blank on New, Do Not Edit)": string;
}

type Props = {
    closeModalFn: () => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
};

type State = {
    uploadType: string;
    showResults: boolean;
    isProcessing: boolean;
    file: any;
    fileDropRejected: boolean;
    fileTypeRejected: boolean;
    csvData?: any;
    uploadActive: boolean;
    processedItemsDetail: IProcessedItemsDetails | null;
};

class VendorSourcesUploadModal extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            processedItemsDetail: null,
            uploadType: "",
            showResults: false,
            isProcessing: false,
            file: null,
            fileDropRejected: false,
            fileTypeRejected: false,
            uploadActive: false,
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.PurchaseOrderOnProcessVendorSourcesCSV, this.onProcessVendorSourcesCSV);
        this.props.socket.on(EndpointsEnum.PurchaseOrderOnProcessVendorSourcesLocationsCSV, this.onProcessVendorSourcesLocationsCSV);
        this.props.socket.on(EndpointsEnum.PurchaseOrderOnProcessVendorSourcesCatalogItemsCSV, this.onProcessVendorSourcesCatalogItemsCSV);
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.PurchaseOrderOnProcessVendorSourcesCSV, this.onProcessVendorSourcesCSV);
        this.props.socket.removeListener(
            EndpointsEnum.PurchaseOrderOnProcessVendorSourcesLocationsCSV,
            this.onProcessVendorSourcesLocationsCSV
        );
        this.props.socket.removeListener(
            EndpointsEnum.PurchaseOrderOnProcessVendorSourcesCatalogItemsCSV,
            this.onProcessVendorSourcesCatalogItemsCSV
        );
    }

    closeModal = () => {
        this.props.closeModalFn();
    };

    create = () => {};

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    csvLoaded = (csvData?: ParseResult<any>) => {
        if (csvData) {
            this.setState({
                csvData,
            });
        }
    };

    setupVendorSourcesCSVData = (csvData: ParseResult<IVendorSourceCSVRow>) => {
        const rows = csvData.data.map((data) => {
            return {
                name: data.Name,
                email: data.Email,
                shipToAddrLineOne: data["Ship To Address Line One"],
                shipToAddrLineTwo: data["Ship To Address Line Two"],
                shipToAddrLineThree: data["Ship To Address Line Three"],
                shipToCity: data["Ship To City"],
                shipToState: data["Ship To State"],
                shipToPostalCode: data["Ship To Postal Code"],
                shipToCountry: data["Ship To Country"],
                shipToPhone: data["Ship To Phone"],
                shipToFax: data["Ship To Fax"],
                billToAddrLineOne: data["Bill To Address Line One"],
                billToAddrLineTwo: data["Bill To Address Line Two"],
                billToAddrLineThree: data["Bill To Address Line Three"],
                billToCity: data["Bill To City"],
                billToState: data["Bill To State"],
                billToPostalCode: data["Bill To Postal Code"],
                billToCountry: data["Bill To Country"],
                billToPhone: data["Bill To Phone"],
                billToFax: data["Bill To Fax"],
                guid: data["Vendor Source Guid (Blank on New, Do Not Edit)"],
            } as IVendorSourceUploadDataRow;
        });

        const payload: IProcessVendorSourcesCsvDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            rows: JSON.stringify(rows),
        };

        this.props.socket.emit(EndpointsEnum.PurchaseOrderProcessVendorSourcesCSV, payload);
    };

    onProcessVendorSourcesCSV = (data: IOnProcessVendorSourcesCsvDTO) => {
        const errorDetails: { item: string; error: string }[] = (data.errorItems || []).map((item) => {
            return {
                error: item.reason || "",
                item: item.item || "",
            };
        });

        this.setState({
            showResults: true,
            processedItemsDetail: {
                totalProcessed: data.totalRecords,
                totalErrored: data.recordsErrored,
                totalCreated: data.recordsCreated,
                totalUpdated: data.recordsUpdated,
                errorDetails,
            },
        });
    };

    setupLocationsCSVData = (csvData: ParseResult<IVendorSourceLocationCSVRow>) => {
        const rows: IVendorSourceLocationUploadDataRow[] = csvData.data.map((item) => {
            return {
                vendorSourceName: item["Vendor Source Name"],
                name: item.Name,
                internalId: item["Internal Id"],
                addressLineOne: item["Address Line One"],
                addressLineTwo: item["Address Line Two"],
                addressLineThree: item["Address Line Three"],
                city: item.City,
                state: item.State,
                postalCode: item["Postal Code"],
                country: item.Country,
                guid: item["Location Guid (Blank on New, Do Not Edit)"] || "",
            };
        });

        const payload: IProcessVendorSourcesLocationsCsvDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            rows: JSON.stringify(rows),
        };

        this.props.socket.emit(EndpointsEnum.PurchaseOrderProcessVendorSourcesLocationsCSV, payload);
    };

    onProcessVendorSourcesLocationsCSV = (data: IOnProcessVendorSourcesLocationsCsvDTO) => {
        const errorDetails: { item: string; error: string }[] = (data.errorItems || []).map((item) => {
            return {
                error: item.reason || "",
                item: item.item || "",
            };
        });

        const processedItemsDetail = {
            totalProcessed: data.totalRecords,
            totalErrored: data.recordsErrored,
            totalCreated: data.recordsCreated,
            totalUpdated: data.recordsUpdated,
            errorDetails,
        };

        this.setState({
            showResults: true,
            processedItemsDetail,
        });
    };

    onProcessVendorSourcesCatalogItemsCSV = (data: IOnProcessVendorSourcesCatalogItemsCsvDTO) => {
        const errorDetails: { item: string; error: string }[] = (data.errorItems || []).map((item) => {
            return {
                error: item.reason || "",
                item: `${item.sku} - ${item.item}`,
            };
        });

        this.setState({
            showResults: true,
            processedItemsDetail: {
                totalProcessed: data.totalRecords,
                totalErrored: data.recordsErrored,
                totalCreated: data.recordsCreated,
                totalUpdated: data.recordsUpdated,
                errorDetails,
            },
        });
    };

    processUploadType = () => {
        if (this.state.uploadType && this.state.csvData) {
            switch (this.state.uploadType) {
                case "vendor_sources":
                    this.setupVendorSourcesCSVData(this.state.csvData);
                    break;

                case "locations":
                    this.setupLocationsCSVData(this.state.csvData);
                    break;
            }
        }
    };

    doUpload = () => {
        this.setState(
            {
                uploadActive: true,
            },
            () => {
                this.processUploadType();
            }
        );
    };

    dismissProcessed = () => {
        this.setState({
            showResults: false,
            processedItemsDetail: null,
        });
    };

    render() {
        const uploadOptions = [
            {
                title: "vendor_sources",
                value: "vendor_sources",
            },
            {
                title: "vendor_sources_locations",
                value: "locations",
            },
            {
                title: "vendor_sources_catalog_items",
                value: "catalog_items",
            },
        ];
        return (
            <div className={"VendorSourcesUploadModal p-2"}>
                <div className={"w-100"} style={{ height: "2rem" }}>
                    <div className={"d-flex justify-content-between"}>
                        <OwTitle leftIconName={"fad fa-cloud-upload-alt"} title={"upload_update"} tag={"h3"} />

                        <div>
                            <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={this.closeModal} />
                        </div>
                    </div>
                </div>

                <div className={"mt-3"}>
                    <div>
                        <OwLabel title={"upload_type"} noBottomMargin={true} />
                    </div>
                    <OwSelectOption
                        name={"uploadType"}
                        valueProp={"value"}
                        titleProp={"title"}
                        options={uploadOptions}
                        fn={this.handleChange}
                        selectedOption={this.state}
                        selectedOptionProp={"uploadType"}
                        translateTitle={true}
                        showBlankFirst={true}
                    />
                </div>

                {this.state.showResults ? null : this.state.uploadType === "catalog_items" ? (
                    <div className={"mt-4"}>
                        <div className={"drop-area"}>
                            <OwS3Uploader
                                resourceType={FileUploadResourceTypeEnum.vendorSourceCatalogItemsCsv}
                                s3UploadType={S3UploadTypeEnum.VENDOR_SOURCE_CATALOG_ITEMS_CSV}
                                isS3Upload={true}
                                socket={this.props.socket}
                                userModel={this.props.userModel}
                                supplierModel={this.props.supplierModel}
                                notifyFn={this.props.notifyFn}
                                isReadOnly={false}
                                dropOnly={false}
                            />
                        </div>
                    </div>
                ) : (
                    <div className={"mt-4"}>
                        <div className={"drop-area"}>
                            <OwCsvReader onFileLoaded={this.csvLoaded} isProcessing={this.state.isProcessing} />
                        </div>

                        <div>
                            {this.state.file ? (
                                <div>
                                    <OwLabel title={"loaded_file"} noBottomMargin={true} isBold={true} isUnderline={true} />:{" "}
                                    {this.state.file.name}
                                </div>
                            ) : null}
                            <div className={"d-flex justify-content-between error-section"}>
                                <OwLabel
                                    className={"text-danger mt-2 " + (this.state.fileDropRejected ? "" : "d-none")}
                                    title={"file_drop_rejected_too_big"}
                                />
                                <OwLabel
                                    className={"text-danger mt-2 " + (this.state.fileTypeRejected ? "" : "d-none")}
                                    title={"file_type_invalid"}
                                />
                            </div>
                        </div>

                        <div className={"mt-3"}>
                            <OwButton title={"upload"} fn={this.doUpload} />
                        </div>
                    </div>
                )}

                {this.state.showResults ? (
                    <div>
                        <OwProcessedItemsDetails
                            details={this.state.processedItemsDetail}
                            dismissProcessedDetails={this.dismissProcessed}
                            visibleOverride={true}
                        />
                    </div>
                ) : null}
            </div>
        );
    }
}

export default VendorSourcesUploadModal;
